export enum WidgetType {
  FLASH_CARD = 0,
  BAR_CHART = 1,
  STACKED_BAR_CHART = 2,
  TABLE = 3,
  FEEDBACK_BANNER = 4,
  ICON_CARDS = 5,
  BENCHMARK_SCORE_CARD = 6,
  SCORE_INFO_CARD = 7,
  MULTI_LEVEL_BAR_CHART = 8,
  HERO_DIMENSION = 9,
  DIMENSION_SCORE_CARD = 10,
  RECOMMENDATIONS_CARD = 11,
  BAR_CHART_WITH_TREND = 12,
  PIE_CHART = 13,
  PIE_CHART_CLUSTER = 14,
  BENCHMARK_LINE_CHART = 15,
  BENCHMARK_PROGRESS_BAR = 16,
}

export enum WidgetErrorState {
  NULL = 0,
  EMPTY = 1,
  API_FAIL = 2,
  DESELECT_FILTER = 3,
  LOADING = 4,
}
